module.exports = "<svg><svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg.svg
// module id = 503
// module chunks = 1